import CollectionsBootstrap from 'modules/employees/lib/SettingsCollectionsBootstrap'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import DefaultEndDate from './DefaultEndDate'

const Container = () => {
  return (
    <ResponsivePage.Body showHeader={false}>
      <DefaultEndDate />
    </ResponsivePage.Body>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
